{
  "en": {
    "search": {
      "placeholders": {
        "query": "Search for questions or keywords"
      },
      "title": "Search"
    }
  }
}
